const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-list') &&
		document.querySelectorAll('.js-media-list').length > 0
	) {
		document.querySelectorAll('.js-media-list').forEach((elem, index) => {
			let prevButton = elem
				.closest('.product')
				.querySelector('.product__slider-nav .swiper-button-prev')
			let nextButton = elem
				.closest('.product')
				.querySelector('.product__slider-nav .swiper-button-next')

			let slider = new Swiper(elem, {
				slidesPerView: 1,
				spaceBetween: 1,
				mousewheel: {
					forceToAxis: true,
				},
				autoHeight: false,
				speed: 500,
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: '.product .product__pagination',
					type: 'bullets',
					clickable: true,
				},
				thumbs: {
					swiper:
						document.querySelectorAll('.js-media-sublist').length > 0
							? document.querySelectorAll('.js-media-sublist')[index]?.swiper
							: '',
				},
				on: {
					afterInit: function (swiper) {},
					slideChangeTransitionStart: function () {
						if (document.querySelector('.js-media-sublist')) {
							document
								.querySelector('.js-media-sublist')
								.swiper.slideTo(
									document.querySelector('.js-media-list').swiper.activeIndex
								)
						}
					},
					slideChange: function () {
						window.pauseAllMedia()
						this.params.noSwiping = false

						if (
							document.querySelector('.js-popup-slider') &&
							document.querySelector('.js-popup-slider').swiper
						) {
							document
								.querySelector('.js-popup-slider')
								.swiper.slideTo(this.activeIndex)
						}
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							this.slides[this.activeIndex]
								.querySelector('.shopify-model-viewer-ui__button--poster')
								.removeAttribute('hidden')
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							if (
								!this.slides[this.activeIndex]
									.querySelector('model-viewer')
									.classList.contains('shopify-model-viewer-ui__disabled')
							) {
								this.params.noSwiping = true
								this.params.noSwipingClass = 'swiper-slide'
							} else {
								this.params.noSwiping = false
							}
						}
					},
				},
			})

			if (isUpdate) {
				setTimeout(function () {
					slider.update()
				}, 800)
			}
		})
	}
}

const subSliderInit = (isUpdate, margin) => {
	if (
		document.querySelectorAll('.js-media-sublist') &&
		document.querySelectorAll('.js-media-sublist').length > 0
	) {
		document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
			const slides = elem.querySelectorAll('.product__media-subitem')
			const slidesAmount = slides.length
			const slidesPerView = slidesAmount < 3 ? slidesAmount : 3
			let subSlider = new Swiper(elem, {
				slidesPerView: slidesPerView,
				spaceBetween: 8,
				direction: 'horizontal',
				mousewheel: {
					forceToAxis: true,
				},
				freeMode: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				on: {
					touchEnd: function (s, e) {
						let range = 5
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY)
						if (diff < range || diff > -range) s.allowClick = true
					},
				},
				breakpoints: {
					1100: {
						spaceBetween: margin,
						slidesPerView: slidesPerView,
					},
				},
			})

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update()
				}, 800)
			}
		})
	}
}

const popupSliderInit = (isUpdate) => {
	if (document.querySelector('.js-popup-slider')) {
		let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
			slidesPerView: 1,
			mousewheel: {
				forceToAxis: true,
			},
			zoom: {
				maxRatio: 2,
			},
			navigation: {
				nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
				prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
			},
			pagination: {
				el: '.product-media-modal .product__pagination',
				type: 'bullets',
				clickable: true,
			},
			on: {
				afterInit: function () {
					if (
						document.querySelector('.product__outer--grid-gallery') ||
						document.querySelector('.product__outer--stacked-gallery')
					) {
						document
							.querySelectorAll('.product__media-list .product__media-toggle')
							.forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document
											.querySelector('.js-popup-slider')
											.swiper.slideTo(index)
									}
								})
							})
					}
				},
				slideChange: function () {
					window.pauseAllMedia()
					this.params.noSwiping = false
					document
						.querySelector('.product-media-modal__content')
						.classList.remove('zoom')
				},
				touchMove: function () {
					document
						.querySelector('.product-media-modal__content')
						.classList.remove('zoom')
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector('model-viewer')) {
						this.slides[this.activeIndex]
							.querySelector('.shopify-model-viewer-ui__button--poster')
							.removeAttribute('hidden')
					}
				},
				touchStart: function () {
					if (this.slides[this.activeIndex].querySelector('model-viewer')) {
						if (
							!this.slides[this.activeIndex]
								.querySelector('model-viewer')
								.classList.contains('shopify-model-viewer-ui__disabled')
						) {
							this.params.noSwiping = true
							this.params.noSwipingClass = 'swiper-slide'
						} else {
							this.params.noSwiping = false
						}
					}
				},
			},
		})

		if (isUpdate) {
			setTimeout(function () {
				popupSlider.update()
			}, 800)
		}
	}
}

if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute(
			'content',
			'width=device-width, initial-scale=1, maximum-scale=1'
		)
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	)
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', 'false')

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open')
		)
	})

	if (summary.closest('header-drawer')) return
	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	elementToFocus.focus()
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*'
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => {
		if (!video.closest('.hero__image') && !video.closest('.multirow__video'))
			video.pause()
	})
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus && !elementToFocus.classList.contains('card-focused'))
		elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', {bubbles: true})

		this.querySelectorAll('button').forEach((button) => {
			this.setMinimumDisable()

			button.addEventListener('click', this.onButtonClick.bind(this))
		})

		var eventList = ['paste', 'input']

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ''
				) {
					e.currentTarget.value
				} else {
					e.currentTarget.value = 1
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
					this.previousElementSibling.classList.add('disabled')
				} else {
					this.previousElementSibling.classList.remove('disabled')
				}
			})
		}

		this.input.addEventListener('focusout', function (e) {
			if (e.currentTarget.value === '') {
				e.currentTarget.value = 1
			}
		})
	}

	setMinimumDisable() {
		if (this.input.value == 1) {
			this.querySelector('button[name="minus"]').classList.add('disabled')
		} else {
			this.querySelector('button[name="minus"]').classList.remove('disabled')
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent)

		this.setMinimumDisable()
	}
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

const serializeForm = (form) => {
	const obj = {}
	const formData = new FormData(form)
	for (const key of formData.keys()) {
		obj[key] = formData.get(key)
	}
	return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(
		options['hideElement'] || province_domid
	)

	Shopify.addListener(
		this.countryEl,
		'change',
		Shopify.bind(this.countryHandler, this)
	)

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

const body = document.body
let bodyScrollTop = null
let locked = false

function getScrollbarWidth() {
	return window.innerWidth - document.documentElement.clientWidth
}

function preventScroll(e) {
	e.preventDefault()
}

function lockScroll() {
	bodyScrollTop =
		typeof window.pageYOffset !== 'undefined'
			? window.pageYOffset
			: (document.documentElement || document.body.parentNode || document.body)
					.scrollTop

	var scrollBarWidth = getScrollbarWidth()
	body.style.paddingRight = scrollBarWidth + 'px'

	body.classList.add('scroll-locked')
	locked = true

	document.addEventListener('scroll', preventScroll, {passive: false})
}

function unlockScroll() {
	body.classList.remove('scroll-locked')
	body.style.paddingRight = ''
	window.scrollTo(0, bodyScrollTop)

	document.removeEventListener('scroll', preventScroll)
}

class MenuDrawer extends HTMLElement {
	constructor() {
		super()

		this.mainDetailsToggle = this.querySelector('details')
		const summaryElements = this.querySelectorAll('summary')
		this.addAccessibilityAttributes(summaryElements)

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty(
				'--viewport-height',
				`${window.innerHeight}px`
			)

		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))
		this.bindEvents()

		// Watch for retail mode changes and update mobile nav visibility
		const observer = new MutationObserver(() => {
			this.applyNavVisibilityForMobile()
		})
		observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-retail-mode'] })
		
		// Apply initial nav visibility on page load
		setTimeout(() => this.applyNavVisibilityForMobile(), 0)
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this))
		)
		this.querySelectorAll('button').forEach((button) => {
			if (this.querySelector('.toggle-scheme-button') === button) return
			if (this.querySelector('.header__localization-button') === button) return
			if (this.querySelector('.header__localization-lang-button') === button)
				return
			if (button.classList.contains('mobile-facets__footer__button')) return

			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute('role', 'button')
			element.setAttribute('aria-expanded', false)
			element.setAttribute('aria-controls', element.nextElementSibling.id)
		})
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = event.target.closest('details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute('open')

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement)
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector('button')
			)

			setTimeout(() => {
				// Run after the native toggle so we can detect new state
				detailsElement.classList.add('menu-opening')
				// Only apply visibility when submenu has just opened
				if (detailsElement.hasAttribute('open')) {
					this.applyNavVisibilityForMobile()
				}
			})
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})
		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
		
		// Apply nav visibility when menu opens, after DOM settles
		setTimeout(() => this.applyNavVisibilityForMobile(), 100)
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
			})
			this.mainDetailsToggle
				.querySelector('summary')
				.setAttribute('aria-expanded', false)
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			)
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header =
				this.header || document.querySelector('.shopify-section-header')
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer()
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details')
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening')
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				detailsElement.removeAttribute('open')
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary')
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}

	applyNavVisibilityForMobile() {
		const mode = document.documentElement.getAttribute('data-retail-mode') || 'b2b'
		
		if (mode === 'b2b') {
			// B2B users see all menu items - restore visibility
			const mobileItems = document.querySelectorAll('.menu-drawer__menu li')
			mobileItems.forEach(item => {
				item.style.display = ''
			})
			return
		}
		
		let restrictedKeywords
		if (mode === 'retail-generic') {
			// Retail-generic: hide brands, training, resources, but SHOW "about us" and "news"
			restrictedKeywords = ['brands', 'brand', 'training', 'resource']
		} else if (mode === 'retail') {
			// Full retail: hide brands, training, resources, news, AND "about us"
			restrictedKeywords = ['brands', 'brand', 'training', 'resource', 'news', 'about']
		} else {
			// Unknown mode - default to hiding everything except shop
			restrictedKeywords = ['brands', 'brand', 'training', 'resource', 'news', 'about']
		}
		
		// Hide mobile menu items (same logic as desktop)
		const mobileItems = document.querySelectorAll('.menu-drawer__menu li')
		mobileItems.forEach(item => {
			const linkElement = item.querySelector('a, button, summary')
			const itemText = linkElement ? linkElement.textContent.trim().toLowerCase() : item.textContent.trim().toLowerCase()
			const shouldHide = restrictedKeywords.some(keyword => itemText.includes(keyword))
			item.style.display = shouldHide ? 'none' : ''
		})
	}
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}

	openMenuDrawer(summaryElement) {
		this.headerWrapper = document.querySelector('.header-wrapper')
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.headerWrapper.getBoundingClientRect().top)}px`
		)
		const main = document.querySelector('main')
		if (
			main
				.querySelectorAll('.shopify-section')[0]
				?.classList.contains('section--has-overlay')
		) {
		}

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})

		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
		
		// Apply nav visibility when menu opens, after DOM settles
		setTimeout(() => this.applyNavVisibilityForMobile(), 100)
	}
}

customElements.define('header-drawer', HeaderDrawer)

class LocalizationForm extends HTMLElement {
	constructor() {
		super()
		this.elements = {
			input: this.querySelector(
				'input[name="locale_code"], input[name="country_code"]'
			),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		}

		this.handleDocumentClick = this.handleDocumentClick.bind(this)
		this.elements.button.addEventListener('click', this.togglePanel.bind(this))
		this.addEventListener('keydown', this.onEscapePress.bind(this))

		this.querySelectorAll('a').forEach((item) =>
			item.addEventListener('click', this.onItemClick.bind(this))
		)
	}

	connectedCallback() {
		document.addEventListener('click', this.handleDocumentClick)
	}

	disconnectedCallback() {
		document.removeEventListener('click', this.handleDocumentClick)
	}

	handleDocumentClick(event) {
		if (!this.contains(event.target)) {
			this.hidePanel()
		}
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false')
		this.elements.panel.setAttribute('hidden', true)
	}

	showPanel() {
		this.elements.button.setAttribute('aria-expanded', 'true')
		this.elements.panel.removeAttribute('hidden')
	}

	togglePanel() {
		if (this.elements.button.getAttribute('aria-expanded') === 'true') {
			this.hidePanel()
		} else {
			this.showPanel()
		}
	}

	onEscapePress(event) {
		if (event.key === 'Escape') {
			this.hidePanel()
		}
	}

	onItemClick(event) {
		event.preventDefault()
		this.elements.input.value = event.currentTarget.dataset.value
		this.querySelector('form')?.submit()
		this.hidePanel()
	}
}

customElements.define('localization-form', LocalizationForm)

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			'click',
			this.hide.bind(this, false)
		)
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (
					event.pointerType === 'mouse' &&
					!event.target.closest('deferred-media, product-model')
				)
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()

		if (
			/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
			this.classList.contains('product-media-modal')
		) {
			lockScroll()
		}
	}

	hide() {
		let isOpen = false

		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()

		document.querySelectorAll('body > quick-add-modal').forEach((el) => {
			if (el.hasAttribute('open')) {
				isOpen = true
			}
		})

		if (!isOpen) {
			document.body.classList.remove('overflow-hidden')
			document.body.dispatchEvent(new CustomEvent('modalClosed'))
		}

		const images = document.querySelector('.product-media-modal__content')

		if (images) {
			images.classList.remove('zoom')
		}

		if (
			/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
			this.classList.contains('product-media-modal')
		) {
			unlockScroll()
		}
	}
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) modal.show(button)
		})
	}
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this)
		)
		if (this.getAttribute('data-autoplay')) {
			this.loadContent()
		}
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(
				this.querySelector('template').content.firstElementChild.cloneNode(true)
			)

			this.setAttribute('loaded', true)
			window.pauseAllMedia()
			/*this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();*/

			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (this.getAttribute('data-autoplay')) {
							if (deferredElement.nodeName == 'VIDEO') {
								let playPromise = entry.target.play()
								if (playPromise !== undefined) {
									playPromise.then((_) => {}).catch((error) => {})
								}
							} else {
								if (entry.target.classList.contains('js-youtube')) {
									entry.target.contentWindow.postMessage(
										'{"event":"command","func":"' +
											'playVideo' +
											'","args":""}',
										'*'
									)
								} else {
									entry.target.contentWindow.postMessage(
										'{"method":"play"}',
										'*'
									)
								}
							}
							//entry.target.play()
						}
					} else {
						if (deferredElement.nodeName == 'VIDEO') {
							entry.target.pause()
						} else {
							if (entry.target.classList.contains('js-youtube')) {
								entry.target.contentWindow.postMessage(
									'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
									'*'
								)
							} else {
								entry.target.contentWindow.postMessage(
									'{"method":"pause"}',
									'*'
								)
							}
						}
					}
				})
			})

			const deferredElement = this.appendChild(
				content.querySelector('video, model-viewer, iframe')
			)
			//if (focus) deferredElement.focus();

			if (
				deferredElement.nodeName == 'VIDEO' ||
				deferredElement.nodeName == 'IFRAME'
			) {
				// force autoplay for safari

				if (this.classList.contains('video-section__media')) {
					if (deferredElement.nodeName == 'VIDEO') {
						let playPromise = deferredElement.play()
						if (playPromise !== undefined) {
							playPromise.then((_) => {}).catch((error) => {})
						}
					}

					videoObserver.observe(deferredElement)
				} else {
					deferredElement.play()
				}
			}

			if (
				this.closest('.swiper')?.swiper.slides[
					this.closest('.swiper').swiper.activeIndex
				].querySelector('model-viewer')
			) {
				if (
					!this.closest('.swiper')
						.swiper.slides[
							this.closest('.swiper').swiper.activeIndex
						].querySelector('model-viewer')
						.classList.contains('shopify-model-viewer-ui__disabled')
				) {
					this.closest('.swiper').swiper.params.noSwiping = true
					this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide'
				}
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
	}

	onVariantChange() {
		this.updateOptions()
		this.updateMasterId()
		this.toggleAddButton(true, '')
		this.updatePickupAvailability()
		this.updateVariantStatuses()

		if (!this.currentVariant) {
			this.toggleAddButton(true, '')
			this.setUnavailable()
		} else {
			if (this.currentVariant?.featured_media) {
				this.updateMedia(
					`${this.dataset.section}-${this.currentVariant.featured_media.id}`
				)
			}
			this.updateURL()
			this.updateVariantInput()
			this.renderProductInfo()
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('.js-radio-colors'))

		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll('input')).find(
					(radio) => radio.checked
				).value
			})
		)
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				this.options.sort()
				variant.options.sort()

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option
					})
					.includes(false)
			})
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	updateMedia(mediaId) {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return
		const currentSection = document.querySelector(
			`[data-section="main-${this.dataset.section}"]`
		)
		this.mediaList = currentSection.querySelector('.product__media-list')
		const activeMedia = this.mediaList.querySelector(
			`[data-media-id="${mediaId}"]`
		)
		this.mediaList.querySelectorAll('[data-media-id]').forEach((element) => {
			element.classList.remove('active')
		})
		if (activeMedia) activeMedia.classList.add('active')

		const swiperWrappers = document.querySelectorAll('.product__media-wrapper')

		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
				)

				if (elem.querySelector('.js-media-list')) {
					elem
						.querySelector('.js-media-list')
						.swiper.slideTo(
							elem
								.querySelector('.js-media-list')
								.swiper.slides.indexOf(newMedia)
						)
				}
			}
		})
	}

	updateURL() {
		if (!this.classList.contains('featured-product-radios')) {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return
			window.history.replaceState(
				{},
				'',
				`${this.dataset.url}?variant=${this.currentVariant.id}`
			)
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', {bubbles: true}))
		})
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1
		)
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			]
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(':checked').value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled', 'always-clickable')
					input.disabled = false
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							'[value]',
							input.getAttribute('value')
						)
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')

					if (this.dataset.unavailableOptionsClickable === 'true') {
						input.classList.add('always-clickable')
					} else {
						input.disabled = true
					}
				}
			}
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return

				const html = new DOMParser().parseFromString(responseText, 'text/html')
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				)
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				)
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				)
				const colorNameSource = html.getElementById(
					`ColorName-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const colorNameDestination = document.getElementById(
					`ColorName-${this.dataset.section}`
				)

				if (source && destination) destination.innerHTML = source.innerHTML
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML
					skuDestination.classList.toggle(
						'visibility-hidden',
						skuSource.classList.contains('visibility-hidden')
					)
				}
				if (colorNameSource && colorNameDestination)
					colorNameDestination.innerHTML = colorNameSource.innerHTML

				const price = document.getElementById(`price-${this.dataset.section}`)

				if (price) price.classList.remove('visibility-hidden')

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						'visibility-hidden',
						inventorySource.innerText === ''
					)

				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut
				)
			})
	}

	toggleAddButton(disable = true, text) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		if (!addButton) return
		const addButtonText =
			addButton.querySelector('.button__label') ||
			addButton.querySelector('span')

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = window.variantStrings.addToCart
		}
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		)
		const addButton = button.querySelector('[name="add"]')
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`
		)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)

		if (!addButton) return
		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (inventory) inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled', 'always-clickable')
				input.disabled = false
			} else {
				input.classList.add('disabled')

				if (this.dataset.unavailableOptionsClickable === 'true') {
					input.classList.add('always-clickable')
				} else {
					input.disabled = true
				}
			}
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked
			).value
		})
	}
}

customElements.define('variant-radios', VariantRadios)

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll('.field--pass')

		passwordField.forEach((el) => {
			const input = el.querySelector('input')
			const btnWrapper = el.querySelector('.button-pass-visibility')
			const btnOpen = el.querySelector('.icon-eye-close')
			const btnClose = el.querySelector('.icon-eye')

			input.addEventListener('input', () => {
				input.value !== ''
					? (btnWrapper.style.display = 'block')
					: (btnWrapper.style.display = 'none')
			})

			btnOpen.addEventListener('click', () => {
				input.type = 'text'
				btnOpen.style.display = 'none'
				btnClose.style.display = 'block'
			})

			btnClose.addEventListener('click', () => {
				input.type = 'password'
				btnOpen.style.display = 'block'
				btnClose.style.display = 'none'
			})
		})
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

					/* Color swatches */
					const generateSrcset = (image, widths = []) => {
						const imageUrl = new URL(image['src'])
						return widths
							.filter((width) => width <= image['width'])
							.map((width) => {
								imageUrl.searchParams.set('width', width.toString())
								return `${imageUrl.href} ${width}w`
							})
							.join(', ')
					}

					const createImageElement = (image, classes, sizes, productTitle) => {
						const previewImage = image['preview_image']
						const newImage = new Image(
							previewImage['width'],
							previewImage['height']
						)
						newImage.className = classes
						newImage.alt = image['alt'] || productTitle
						newImage.sizes = sizes
						newImage.src = previewImage['src']
						newImage.srcset = generateSrcset(
							previewImage,
							[165, 360, 533, 720, 940, 1066]
						)
						newImage.loading = 'lazy'
						return newImage
					}

					const checkSwatches = () => {
						document
							.querySelectorAll('.js-color-swatches-wrapper')
							.forEach((wrapper) => {
								wrapper
									.querySelectorAll('.js-color-swatches input')
									.forEach((input) => {
										input.addEventListener('click', (event) => {
											const primaryImage =
												wrapper.querySelector('.media--first')
											const secondaryImage =
												wrapper.querySelector('.media--second')
											const handleProduct = wrapper.dataset.product

											if (event.currentTarget.checked && primaryImage) {
												wrapper
													.querySelector('.js-color-swatches-link')
													.setAttribute(
														'href',
														event.currentTarget.dataset.variantLink
													)
												const currentColor = event.currentTarget.value

												jQuery.getJSON(
													window.Shopify.routes.root +
														`products/${handleProduct}.js`,
													function (product) {
														const variant = product.variants.filter(
															(item) =>
																item.featured_media != null &&
																item.options.includes(currentColor)
														)[0]

														if (variant) {
															const newPrimaryImage = createImageElement(
																variant['featured_media'],
																primaryImage.className,
																primaryImage.sizes,
																product.title
															)

															if (newPrimaryImage.src !== primaryImage.src) {
																let flag = false
																if (secondaryImage) {
																	const secondaryImagePathname = new URL(
																		secondaryImage.src
																	).pathname
																	const newPrimaryImagePathname = new URL(
																		newPrimaryImage.src
																	).pathname

																	if (
																		secondaryImagePathname ==
																		newPrimaryImagePathname
																	) {
																		primaryImage.remove()
																		secondaryImage.classList.remove(
																			'media--second'
																		)
																		secondaryImage.classList.add('media--first')
																		flag = true
																	}
																}
																if (flag == false) {
																	primaryImage.animate(
																		{opacity: [1, 0]},
																		{
																			duration: 200,
																			easing: 'ease-in',
																			fill: 'forwards',
																		}
																	).finished
																	setTimeout(function () {
																		primaryImage.replaceWith(newPrimaryImage)
																		newPrimaryImage.animate(
																			{opacity: [0, 1]},
																			{duration: 200, easing: 'ease-in'}
																		)
																		if (secondaryImage) {
																			secondaryImage.remove()
																		}
																	}, 200)
																}
															}
														}
													}
												)
											}
										})
									})
							})
					}

					checkSwatches()

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll('.card__inner')
						let top = 0

						if (imageWrapper) {
							top = imageWrapper[0].offsetHeight / 2
						} else {
							top = 50
						}

						return top
					}

					const initSlider = () => {
						let mobileLayout = 1
						if (this.dataset.mobileLayout) {
							mobileLayout = this.dataset.mobileLayout
						}
						let slider = new Swiper(
							this.querySelector('.js-recommendation-swiper'),
							{
								slidesPerView: mobileLayout,
								mousewheel: {
									forceToAxis: true,
								},
								slidesPerGroup: 1,
								spaceBetween: 8,
								speed: 500,
								navigation: {
									nextEl: this.querySelector(
										'.product-recommendations__slider-nav .swiper-button-next'
									),
									prevEl: this.querySelector(
										'.product-recommendations__slider-nav .swiper-button-prev'
									),
								},
								breakpoints: {
									576: {
										slidesPerView: 2,
										slidesPerGroup: 2,
									},
									750: {
										slidesPerView: 3,
										slidesPerGroup: 3,
										spaceBetween: 24,
									},
								},
							}
						)
					}

					const initSection = () => {
						const section = this

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries
							let top = calcTop(section)
							if (section.querySelector('.product-recommendations__slider-nav'))
								section.querySelector(
									'.product-recommendations__slider-nav'
								).style.top = top + 'px'
						})

						sectionResizeObserver.observe(section)

						initSlider()
					}

					initSection()
				})
				.catch((e) => {
					console.error(e)
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this)
	}
}

customElements.define('product-recommendations', ProductRecommendations)
;(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById('MainContent')
		const sections = main.querySelectorAll('.shopify-section')
		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector(
				'.section--has-overlay'
			)
			const headerGroupSections = document.querySelectorAll(
				'.shopify-section-group-header-group'
			)
			const header = document.querySelector('.shopify-section-header')

			if (sectionFirstChild) {
				if (sectionFirstChild.classList.contains('section--has-overlay')) {
					if (headerGroupSections[headerGroupSections.length - 1] === header) {
						sections[0].classList.remove('not-margin')

						if (sectionFirstChild.classList.contains('section--header-light')) {
							header.classList.add('color-background-overlay')
						} else {
							header.classList.remove('color-background-overlay')
						}
					} else {
						sections[0].classList.add('not-margin')
						header.classList.remove('color-background-overlay')
					}
				} else {
					sections[0].classList.remove('not-margin')

					header.classList.remove('color-background-overlay')
				}
			} else {
				header.classList.remove('color-background-overlay')
			}
		}
	}

	initHeaderOverlay()

	document.addEventListener('shopify:section:load', initHeaderOverlay)
	document.addEventListener('shopify:section:unload', initHeaderOverlay)
	document.addEventListener('shopify:section:reorder', initHeaderOverlay)
})()

function formatMoney(cents, format = '') {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '')
	}
	cents = parseInt(cents, 10)
	let value = ''

	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || theme.moneyFormat

	function formatWithDelimiters(
		number,
		precision = 2,
		thousands = ',',
		decimal = '.'
	) {
		if (isNaN(number) || number == null) {
			return '0'
		}

		number = (number / 100.0).toFixed(precision)

		const parts = number.split('.')
		const dollarsAmount = parts[0].replace(
			/(\d)(?=(\d{3})+(?!\d))/g,
			`$1${thousands}`
		)
		const centsAmount = precision > 0 ? decimal + parts[1] : ''

		return dollarsAmount + centsAmount
	}

	const match = formatString.match(placeholderRegex)
	const formatType = match ? match[1] : 'amount'

	switch (formatType) {
		case 'amount':
			value = formatWithDelimiters(cents, 2, ',', '.')
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ',', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'", '.')
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',')
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', '.')
			break
		default:
			value = formatWithDelimiters(cents, 2, ',', '.')
	}
	return formatString.replace(placeholderRegex, value)
}

const initUnderlinedTitles = () => {
	let sectionTitles = document.querySelectorAll(
		'.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group) .title--rounded'
	)

	if (sectionTitles.length > 0) {
		sectionTitles.forEach((title) => {
			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				let xs, s, m, l, xl

				if (document.body.clientWidth < 1600) {
					xs = 95
					s = 160
					m = 280
					l = 380
					xl = 520
				} else {
					xs = 95
					s = 200
					m = 360
					l = 450
					xl = 620
				}

				entry.target
					.querySelectorAll('span[style="text-decoration:underline"]')
					.forEach((span) => {
						const titleWidth = span.getBoundingClientRect().width
						span.classList.remove(
							'title--rounded-xs',
							'title--rounded-s',
							'title--rounded-m',
							'title--rounded-l',
							'title--rounded-xl',
							'title--rounded-xxl'
						)
						if (titleWidth < xs) {
							span.classList.add('title--rounded-xs')
						} else if (titleWidth < s) {
							span.classList.add('title--rounded-s')
						} else if (titleWidth < m) {
							span.classList.add('title--rounded-m')
						} else if (titleWidth < l) {
							span.classList.add('title--rounded-l')
						} else if (titleWidth < xl) {
							span.classList.add('title--rounded-xl')
						} else {
							span.classList.add('title--rounded-xxl')
						}
					})
			})

			sectionResizeObserver.observe(title)
		})
	}
}

// =============================================================================
// Engraving Add-On Pricing Display (Retail Mode)
// Shows per-option engraving prices on product pages using the funeral home's
// retail pricing. Only visible when Customily has injected its UI (i.e. this
// product is actually configured for engraving in Customily).
// =============================================================================

const VENDOR_ENGRAVING_OPTIONS = {
	Terrybear: [
		{ sku: 'ENGTEXT', label: 'Text Only Engraving' },
		{ sku: 'ENGART', label: 'Text + Clipart Engraving' }
	],
	'MacKenzie Vault': [
		{ sku: 'MVSTANDARD', label: 'Standard Engraving' }
		// { sku: 'MVCUSTOM', label: 'Custom Engraving' },
		// { sku: 'MVFULLFRAME', label: 'Custom Full-Frame Engraving' }
	]
}

const updateEngravingPriceDisplay = (priceLookup) => {
	// Vendor comes from the price-container data attribute (set in Liquid)
	const priceContainer = document.querySelector('.price-container[data-product-vendor]')
	if (!priceContainer) return

	const vendor = priceContainer.dataset.productVendor
	const engravingOptions = VENDOR_ENGRAVING_OPTIONS[vendor]
	if (!engravingOptions) return // Not a vendor with engraving SKU data

	const parsePrice = value => {
		if (typeof value === 'number') return value
		if (typeof value === 'string') {
			const n = Number(value.replace(/[^0-9.-]/g, ''))
			return Number.isFinite(n) ? n : NaN
		}
		return NaN
	}

	const buildAndInjectDisplay = () => {
		if (document.getElementById('engraving-price-display')) return // already injected

		const items = engravingOptions.map(({ sku, label }) => {
			const raw = priceLookup[sku] ?? priceLookup[sku.toUpperCase()]
			const parsedPrice = parsePrice(raw)
			if (!Number.isFinite(parsedPrice) || parsedPrice <= 0) return null
			const priceInCents = Math.round(parsedPrice * 100)
			const formattedPrice = formatMoney(priceInCents, window.Shopify.money_format)
			return `<span class="engraving-price-item"><span class="engraving-price-label">${label}:</span> <span class="engraving-price-value">+${formattedPrice}</span></span>`
		}).filter(Boolean)

		if (items.length === 0) return

		const displayEl = document.createElement('div')
		displayEl.id = 'engraving-price-display'
		displayEl.className = 'engraving-price-display'
		displayEl.innerHTML = items.join('')

		// Insert right before the .product__buy-buttons-wrapper
		const buyButtonsWrapper = document.querySelector('.product__buy-buttons-wrapper')
		if (buyButtonsWrapper) {
			buyButtonsWrapper.insertAdjacentElement('beforebegin', displayEl)
		} else {
			// Fallback: insert after price wrapper if buy-buttons-wrapper not found
			const priceWrapper = priceContainer.closest('.price-wrapper') || priceContainer.parentElement
			priceWrapper.insertAdjacentElement('afterend', displayEl)
		}
	}

	// True engravability signals: Customily injected its UI for this product,
	// or TeeInBlue has flagged this as a TIB product.
	const isCustomilyActive = () => !!document.querySelector('.customily_set-visibility')
	const isTeeInBlueActive = () => !!(window.teeinblueCampaign && window.teeinblueCampaign.isTeeInBlueProduct)

	if (isCustomilyActive() || isTeeInBlueActive()) {
		buildAndInjectDisplay()
		return
	}

	// Neither service is active yet — watch for async injection
	if (window._engravingObserverActive) return
	window._engravingObserverActive = true

	const engravingObserver = new MutationObserver(() => {
		if (isCustomilyActive() || isTeeInBlueActive()) {
			engravingObserver.disconnect()
			clearTimeout(observerTimeout)
			window._engravingObserverActive = false
			buildAndInjectDisplay()
		}
	})
	engravingObserver.observe(document.body, { childList: true, subtree: true })
	const observerTimeout = setTimeout(() => {
		engravingObserver.disconnect()
		window._engravingObserverActive = false
	}, 15000)
}

// Fetch B2B pricing from database and display it: the main product's own price
// (for multi-variant products only — see below) plus any vendor-specific engraving
// add-on prices. Mirrors retail mode's price-container application (initRetailBranding)
// so both modes render pricing the same way.
const initB2BEngravingPrices = async () => {
	const priceContainer = document.querySelector('.price-container[data-product-vendor]')
	if (!priceContainer) return

	const vendor = priceContainer.dataset.productVendor
	const engravingOptions = VENDOR_ENGRAVING_OPTIONS[vendor] || []
	const vendorSkus = engravingOptions.map(o => o.sku)

	// Single-variant B2B products already get their price from spark-pdp's own UI —
	// only multi-variant products (where spark-pdp's table view is replaced by the
	// native Shopify picker) need the "Price" block itself populated.
	const mainSku = window.SPARK_MULTI_VARIANT ? priceContainer.dataset.productSku : null

	// Confirmed via /api/pricing: Supabase's pricing table is keyed on this product's
	// original base SKU (e.g. "CM-OL"), not the per-Finish variant SKUs Shopify now has
	// (e.g. "CM-OL AMETHYST") — those never got their own pricing rows since all Finish
	// variants of a product share one price. Recover the base SKU as the longest common
	// prefix across this product's variant SKUs, and try it if the exact SKU misses.
	let baseSku = null
	if (mainSku) {
		const picker = document.querySelector('variant-radios, variant-selects')
		const siblingSkus = picker && typeof picker.getVariantData === 'function'
			? picker.getVariantData().map(v => v.sku).filter(Boolean)
			: []
		if (siblingSkus.length > 1) {
			let prefix = siblingSkus[0]
			for (let i = 1; i < siblingSkus.length && prefix; i++) {
				const s = siblingSkus[i]
				let j = 0
				while (j < prefix.length && j < s.length && prefix[j] === s[j]) j++
				prefix = prefix.slice(0, j)
			}
			baseSku = prefix.trim() || null
		}
	}

	const allSkus = [...new Set([mainSku, baseSku, ...vendorSkus].filter(Boolean))]
	if (allSkus.length === 0) return

	const ctx = window.retailContext
	const slug = ctx?.slug

	if (!slug) {
		console.warn('No funeral home slug available for B2B pricing')
		return
	}

	const API_BASE_URL = window.MAGNOLIA?.apiBaseUrl || 'https://magnolia-memorial-api.vercel.app'

	try {
		const response = await fetch(`${API_BASE_URL}/api/pricing/${slug}`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'x-shopify-customer-id': String(window.MAGNOLIA?.customerId || '') },
			body: JSON.stringify({ skus: allSkus })
		})


		if (!response.ok) {
			console.warn('B2B pricing fetch failed')
			return
		}

		const payload = await response.json()
		const prices = payload.data || {}

		// Create price lookup (API returns prices in dollars)
		const priceLookup = {}
		Object.entries(prices).forEach(([sku, value]) => {
			priceLookup[sku] = value
			priceLookup[sku.toUpperCase()] = value
		})

		// Apply the main product's price to the "Price" block, same as retail mode does.
		if (mainSku) {
			const rawPrice = priceLookup[mainSku] ?? priceLookup[mainSku.toUpperCase()]
				?? (baseSku ? (priceLookup[baseSku] ?? priceLookup[baseSku.toUpperCase()]) : undefined)
			const parsedPrice = Number(rawPrice)
			if (Number.isFinite(parsedPrice) && parsedPrice > 0) {
				const priceEl = priceContainer.querySelector('.price-item--regular .price') || priceContainer.querySelector('.price')
				if (priceEl) {
					const priceInCents = Math.round(parsedPrice * 100)
					priceEl.textContent = formatMoney(priceInCents, window.Shopify.money_format)
					priceContainer.classList.add('price-ready')
					// Remove any inline display:none set by SparkLayer's b2c-only handler,
					// same as retail mode does, so the block actually becomes visible.
					priceContainer.style.removeProperty('display')
				}
			}
		}

		if (Object.keys(priceLookup).length > 0) {
			updateEngravingPriceDisplay(priceLookup)
		}
	} catch (err) {
		console.warn('Failed to fetch B2B pricing:', err)
	}
}

// Retail Mode Branding & Pricing Fetch
const initRetailBranding = async () => {
	const ctx = window.retailContext
	if (!ctx || ctx.mode !== 'retail' || !ctx.slug) return

	const normalizeSlug = value => {
		if (!value) return ''
		return String(value)
			.toLowerCase()
			.trim()
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '')
	}

	const normalizedSlug = normalizeSlug(ctx.slug)
	if (!normalizedSlug) return
	ctx.slug = normalizedSlug
	const API_BASE_URL = window.MAGNOLIA?.apiBaseUrl || 'https://magnolia-memorial-api.vercel.app'

	try {
		const priceContainers = Array.from(document.querySelectorAll('.price-container'))
		const pageSkus = priceContainers
			.map(container => (container.dataset.productSku || '').trim())
			.filter(Boolean)

		const parseRetailPriceValue = value => {
			if (typeof value === 'number') return value
			if (typeof value === 'string') {
				const sanitized = value.replace(/[^0-9.-]/g, '')
				const parsed = Number(sanitized)
				return Number.isFinite(parsed) ? parsed : NaN
			}
			return NaN
		}

		const toPriceLookup = source => {
			const lookup = {}
			Object.entries(source || {}).forEach(([sku, value]) => {
				const normalized = String(sku || '').trim()
				if (!normalized) return
				lookup[normalized] = value
				lookup[normalized.toUpperCase()] = value
			})
			return lookup
		}

		const fetchRetailPricing = async skus => {
			if (!Array.isArray(skus) || skus.length === 0) return {}
			const pricingResponse = await fetch(`${API_BASE_URL}/api/pricing/${normalizedSlug}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'x-shopify-customer-id': String(window.MAGNOLIA?.customerId || '') },
				body: JSON.stringify({ skus })
			})

			if (!pricingResponse.ok) {
				console.warn('Pricing API failed; keeping prices hidden')
				return {}
			}

			const pricingPayload = await pricingResponse.json()
			return pricingPayload.data || {}
		}

		// Store default CSS variable values on first run
		if (!window.defaultCssVars) {
			window.defaultCssVars = {}
			const CSS_VARS_TO_MANAGE = [
				'--color-accent',
				'--color-button',
				'--color-background',
				'--color-foreground',
				'--color-button-text',
				'--color-button-text-hover',
				'--color-background-secondary'
			]
			CSS_VARS_TO_MANAGE.forEach(varName => {
				// Capture the current value (from theme editor settings)
				window.defaultCssVars[varName] = getComputedStyle(document.documentElement).getPropertyValue(varName).trim()
			})
		}

		const cacheKey = `retail_branding_${normalizedSlug}`
		const cachedData = localStorage.getItem(cacheKey)
		let branding, prices
		let parsedCache = null

		if (cachedData) {
			try {
				parsedCache = JSON.parse(cachedData)
				// Legacy cache entries written before Phase 1 have no cachedAt timestamp.
				// Treat them as invalid so they get replaced with a fresh, timestamped entry.
				if (parsedCache && !parsedCache.cachedAt) {
					localStorage.removeItem(cacheKey)
					parsedCache = null
				}
			} catch (err) {
				console.warn('Retail cache parse failed, refetching branding/pricing:', err)
			}
		}

		// Track whether any new data is actually fetched so cachedAt is only refreshed
		// when the payload changes. If we serve fully from cache, preserve the original
		// timestamp so Phase 2 freshness comparisons remain accurate.
		let didFetch = false

		if (parsedCache) {
			// Use cached data
			branding = parsedCache.branding || {}
			prices = parsedCache.prices || {}
		} else {
			// Branding is optional: pricing should still work when no branding row exists.
			branding = {}
			prices = {}
			didFetch = true

			try {
				const response = await fetch(`${API_BASE_URL}/api/branding/${normalizedSlug}`)
				if (response.ok) {
					const brandingPayload = await response.json()
					branding = brandingPayload.data || {}
				} else {
					console.warn('Branding API unavailable for this funeral home; continuing with pricing only')
				}
			} catch (err) {
				console.warn('Branding API request failed; continuing with pricing only', err)
			}
		}

		// Include engraving service SKUs in the batch pricing request for engravable product pages
		const priceContainerEl = document.querySelector('.price-container[data-product-vendor]')
		const pageVendor = priceContainerEl?.dataset.productVendor || ''
		const vendorEngravingSkus = (VENDOR_ENGRAVING_OPTIONS[pageVendor] || []).map(o => o.sku)
		const allFetchSkus = [...new Set([...pageSkus, ...vendorEngravingSkus])]

		// Always fetch missing SKUs for the current page; cached prices can be incomplete.
		if (allFetchSkus.length > 0) {
			const priceLookup = toPriceLookup(prices)
			const missingSkus = allFetchSkus.filter(sku => {
				const raw = priceLookup[sku] ?? priceLookup[sku.toUpperCase()]
				const parsed = parseRetailPriceValue(raw)
				return !(Number.isFinite(parsed) && parsed > 0)
			})

			if (missingSkus.length > 0) {
				const fetchedPrices = await fetchRetailPricing(missingSkus)
				prices = { ...(prices || {}), ...(fetchedPrices || {}) }
				didFetch = true
			}
		}

		// Cache both branding and merged pricing for future page loads.
		// Only stamp a fresh cachedAt when new data was actually fetched; otherwise
		// preserve the existing timestamp so Phase 2 freshness checks remain accurate.
		const cachedAt = didFetch ? Date.now() : (parsedCache?.cachedAt ?? Date.now())
		localStorage.setItem(cacheKey, JSON.stringify({ branding: branding || {}, prices: prices || {}, cachedAt }))

		// Apply CSS variables from cached/fetched branding
		const root = document.documentElement
		if (branding.cssVars) {
			Object.entries(branding.cssVars).forEach(([key, value]) => {
				if (value) {
					root.style.setProperty(key, value)
				}
			})
		}

		const headerLinks = document.querySelectorAll('.header__heading-link')
		for (const link of headerLinks) {
			const originalLogo = link.querySelector('img:not(.retail-branded-logo)')
			let brandedLogo = link.querySelector('img.retail-branded-logo')

			if (branding.logoUrl) {
				root.style.setProperty('--retail-logo-url', `url(${branding.logoUrl})`)
				if (!brandedLogo) {
					brandedLogo = document.createElement('img')
					brandedLogo.src = branding.logoUrl
					if (originalLogo) brandedLogo.width = originalLogo.width
					brandedLogo.classList.add('header__heading-logo', 'retail-branded-logo')
					link.appendChild(brandedLogo)
				} else {
					brandedLogo.src = branding.logoUrl
					brandedLogo.classList.remove('hidden')
				}

				if (originalLogo) originalLogo.classList.add('hidden')
			} else {
				// In retail mode without a configured logo, hide logo entirely.
				if (originalLogo) originalLogo.classList.add('hidden')
				if (brandedLogo) brandedLogo.classList.add('hidden')
				root.style.removeProperty('--retail-logo-url')
			}
		}

		window.retailBranding = branding

		// Apply cached/fetched pricing
		const priceLookup = toPriceLookup(prices)
		priceContainers.forEach(container => {
			const sku = container.dataset.productSku
			const retailPrice = priceLookup[sku] ?? priceLookup[(sku || '').toUpperCase()]
			const parsedPrice = parseRetailPriceValue(retailPrice)
			if (Number.isFinite(parsedPrice) && parsedPrice > 0) {
				const priceEl = container.querySelector('.price-item--regular .price') || container.querySelector('.price')
				if (priceEl) {
					// API returns prices in dollars; convert to cents for formatMoney
					const priceInCents = Math.round(parsedPrice * 100)
					const formattedPrice = formatMoney(priceInCents, window.Shopify.money_format)
					priceEl.textContent = formattedPrice
					container.classList.add('price-ready')
					// Remove any inline display:none set by SparkLayer's b2c-only handler
					// so that our retail-mode CSS rule can take effect.
					container.style.removeProperty('display')
				}
			}
		})

		// Display engraving add-on pricing on engravable product pages
		updateEngravingPriceDisplay(priceLookup)
	} catch (err) {
		console.warn('Failed to load retail branding:', err)
		// On error, prices stay hidden (safe default)
	}
}

// ============================================================================
// Customily Validation Function
// ============================================================================

/**
 * Validates Customily personalization fields for cart updates.
 * Extracted from SparkLayer's preCartUpdateListener to support both B2B and retail flows.
 * 
 * @param {string} containerSelector - CSS selector for Customily container (default: '.customily_set-visibility')
 * @returns {object} Validation result with structure:
 *   {
 *     valid: boolean,
 *     errors: string[],
 *     attributes: object,
 *     elementsWithErrors: HTMLElement[]
 *   }
 * 
 * @description
 * - Handles three vendors: Terrybear (Text Only, Text + Clipart), Created Bracelets, MacKenzie Vault
 * - Returns attributes ready to add to cart product customAttributes
 * - Returns error list for display; does NOT modify DOM
 * - Tracks elements that need visual error indicators (red borders)
 */
// ---------------------------------------------------------------------------
// Tee In Blue (TIB) helper utilities
// ---------------------------------------------------------------------------

/**
 * Returns the .tee-field wrapper whose heading text matches the given label.
 * All dynamic TIB layer IDs are unstable; label text is the only reliable key.
 */
function getTIBFieldByLabel(labelText) {
	return [...document.querySelectorAll('.tee-field')].find(
		(f) => f.querySelector('.tee-field__heading > span:first-child')?.textContent.trim() === labelText
	)
}

/**
 * Returns the human-readable selected text of a TIB <select> field.
 * TIB option values are numeric IDs; we always want the visible label.
 */
function getTIBSelectText(labelText) {
	const field = getTIBFieldByLabel(labelText)
	if (!field) return ''
	const sel = field.querySelector('select')
	if (sel) return sel.options[sel.selectedIndex]?.text?.trim() || ''

	// Artwork 2.0 renders some dropdowns (e.g. Font) as a custom widget with no <select> element
	const current = field.querySelector('.tee-custom-select__current')
	if (current && !current.classList.contains('tee-custom-select__placeholder')) {
		return current.textContent.trim()
	}
	return ''
}

/**
 * Returns all visible TIB text-line fields as { label, value, required, inputEl, fieldEl }.
 * Matched by the presence of a text input rather than a `tee-field--text` modifier class,
 * since Artwork 2.0 renders these fields under different modifier classes (e.g. `tee-field--curve_text`).
 * Fields with no value are included so required validation can flag them.
 */
function getTIBTextLines() {
	return [...document.querySelectorAll('.tee-field')]
		.filter((f) => f.querySelector('input[type="text"], textarea'))
		.map((f) => {
			const label = f.querySelector('.tee-field__heading > span:first-child')?.textContent.trim() || ''
			const inputEl = f.querySelector('input[type="text"], textarea')
			const required = !!f.querySelector('.tee-asterisk')
			return { label, value: inputEl?.value.trim() || '', required, inputEl, fieldEl: f }
		})
}

/**
 * Returns info about the currently checked TIB clipart radio, or null if none.
 */
function getTIBClipart() {
	const vectorField = document.querySelector('.tee-field--vector')
	if (!vectorField) return null
	const checked = vectorField.querySelector('input[type="radio"]:checked')
	if (!checked) return null
	const imgEl = document.querySelector(`label[for="${checked.id}"] img.tee-clipart-thumbnail`)
	return { name: imgEl?.alt || checked.value, value: checked.value, fieldEl: vectorField }
}

/**
 * Returns the selected display name from any TIB radio-group field identified by label text,
 * or null if none is checked. Works for Finish, clipart, and any other radio field.
 */
function getTIBRadioFieldValue(labelText) {
	const field = getTIBFieldByLabel(labelText)
	if (!field) return null
	const checked = field.querySelector('input[type="radio"]:checked')
	if (!checked) return null
	const imgEl = field.querySelector(`label[for="${checked.id}"] img.tee-clipart-thumbnail`)
	return { name: imgEl?.alt || checked.value, fieldEl: field }
}

/** Marks a TIB field's input area with a red outline and records it in the result. */
function tibMarkError(fieldEl, result) {
	const inputArea = fieldEl?.querySelector('.tee-field__input') || fieldEl
	if (inputArea) {
		inputArea.style.outline = '2px solid red'
		result.elementsWithErrors.push(inputArea)
	}
}

/** Clears error outlines from all visible TIB fields. */
function tibClearErrors() {
	document.querySelectorAll('.tee-field .tee-field__input').forEach((el) => {
		el.style.outline = ''
	})
}

// ---------------------------------------------------------------------------
// Main entry point — called by preCartUpdateListener in theme.liquid
// ---------------------------------------------------------------------------

function validateCustomily(containerSelector = '.customily_set-visibility') {
	const result = {
		valid: true,
		errors: [],
		attributes: {},
		elementsWithErrors: []
	}

	// Route to Tee In Blue validation when TIB has loaded for this product
	if (window.teeinblueCampaign && window.teeinblueCampaign.isTeeInBlueProduct) {
		return validateTeeInBlue(result)
	}

	// Legacy Customily path (products not yet migrated to TIB)
	const container = document.querySelector(containerSelector)
	if (!container) {
		// No personalisation form on this product — that's fine
		return result
	}

	const vendorName = document.documentElement.getAttribute('data-product-vendor') || 'Terrybear'

	if (vendorName === 'Terrybear') {
		return validateTerrybearCustomily(container, result)
	} else if (vendorName === 'Created Bracelets') {
		return validateCreatedBraceletsCustomily(container, result)
	} else if (vendorName === 'MacKenzie Vault') {
		return validateMacKenzieVaultCustomily(container, result)
	}

	return result
}

// ---------------------------------------------------------------------------
// Tee In Blue validation — dispatches by vendor
// ---------------------------------------------------------------------------

function validateTeeInBlue(result) {
	tibClearErrors()
	const vendorName = document.documentElement.getAttribute('data-product-vendor') || ''

	if (vendorName === 'Terrybear') {
		return validateTIBTerrybear(result)
	} else if (vendorName === 'MacKenzie Vault') {
		return validateTIBMacKenzieVault(result)
	} else if (vendorName === 'Created Bracelets') {
		return validateTIBCreatedBracelets(result)
	}

	// Unknown vendor — no personalisation validation needed
	return result
}

// ---------------------------------------------------------------------------
// Terrybear TIB validation
// Engraving dropdown options: No | Text-Only | Text + Clipart
// ---------------------------------------------------------------------------

function validateTIBTerrybear(result) {
	const engravingField = getTIBFieldByLabel('Engraving')
	if (!engravingField) return result

	const engravingText = getTIBSelectText('Engraving')

	switch (engravingText) {
		case 'No':
			result.attributes['Add Engraving'] = 'No'
			return result

		case 'Text-Only':
			return validateTIBTerrybearTextOnly(result)

		case 'Text + Clipart':
			return validateTIBTerrybearTextAndClipart(result)

		default:
			result.valid = false
			result.errors.push('No personalization options selected, please try again')
			return result
	}
}

function validateTIBTerrybearTextOnly(result) {
	result.attributes['Add Engraving'] = 'Yes'

	const fontText = getTIBSelectText('Font')
	if (fontText && fontText !== 'Choose an option') {
		result.attributes['Font'] = fontText
	}

	const etchColor = getTIBSelectText('Etch Color')
	if (etchColor && etchColor !== 'Choose an option') {
		result.attributes['Etch Color'] = etchColor
	}

	const lines = getTIBTextLines()
	let line1Missing = false

	lines.forEach((line, idx) => {
		if (line.required && line.value === '') {
			line1Missing = true
			tibMarkError(line.fieldEl, result)
		} else if (line.value !== '') {
			result.attributes[`Line ${idx + 1}`] = line.value
		}
	})

	if (line1Missing) {
		result.valid = false
		result.errors.push('Please complete all required fields')
	}

	return result
}

function validateTIBTerrybearTextAndClipart(result) {
	result.attributes['Add Engraving'] = 'Yes'

	const fontText = getTIBSelectText('Font')
	if (fontText && fontText !== 'Choose an option') {
		result.attributes['Font'] = fontText
	}

	const etchColor = getTIBSelectText('Etch Color')
	if (etchColor && etchColor !== 'Choose an option') {
		result.attributes['Etch Color'] = etchColor
	}

	const lines = getTIBTextLines()
	let line1Missing = false

	lines.forEach((line, idx) => {
		if (line.required && line.value === '') {
			line1Missing = true
			tibMarkError(line.fieldEl, result)
		} else if (line.value !== '') {
			result.attributes[`Line ${idx + 1}`] = line.value
		}
	})

	const clipart = getTIBClipart()
	if (clipart) {
		result.attributes['Clipart'] = clipart.name
	} else {
		result.valid = false
		result.errors.push('Please select one image')
		const vectorField = document.querySelector('.tee-field--vector')
		tibMarkError(vectorField, result)
	}

	if (line1Missing) {
		result.valid = false
		result.errors.push('Please complete all required fields')
	}

	return result
}

// ---------------------------------------------------------------------------
// MacKenzie Vault TIB validation
// Engraving dropdown options: No | Standard | Custom | Custom Full-Frame
// ---------------------------------------------------------------------------

function validateTIBMacKenzieVault(result) {
	const engravingText = getTIBSelectText('Engraving')

	if (!engravingText || engravingText === 'Choose an option') {
		result.valid = false
		result.errors.push('No personalization options selected, please try again')
		return result
	}

	// Finish is being migrated from a TIB personalization field to a product variant
	// one urn at a time. Migrated products no longer render a TIB Finish field — Finish
	// comes from the variant picker instead (see preCartUpdateListener in theme.liquid).
	// Products not yet migrated still render the TIB Finish field, so pull it from there.
	// TODO: remove this fallback once all MacKenzie Vault urns use variant-based Finish.
	const finishField = getTIBFieldByLabel('Finish')
	if (finishField) {
		const finish = getTIBRadioFieldValue('Finish')
		if (finish) {
			result.attributes['Finish'] = finish.name
		} else {
			result.valid = false
			result.errors.push('Please select a finish')
			tibMarkError(finishField, result)
		}
	}

	// Both "Standard (Text-Only)" and "Standard (Text + Clipart)" are stored as "Standard"
	result.attributes['Add Engraving'] = engravingText === 'No' ? 'No' : 'Standard'

	if (engravingText === 'No') return result

	// Fields that appear for engraving types other than No
	const font = getTIBSelectText('Font')
	if (font && font !== 'Choose an option') {
		result.attributes['Font'] = font
	}

	const etchColor = getTIBSelectText('Etch Color')
	if (etchColor && etchColor !== 'Choose an option') {
		result.attributes['Etch Color'] = etchColor
	}

	const lines = getTIBTextLines()
	lines.forEach((line, idx) => {
		if (line.value !== '') {
			result.attributes[`Line ${idx + 1}`] = line.value
		}
	})

	// Clipart is optional — add attribute only if one is selected
	const clipart = getTIBClipart()
	if (clipart) {
		result.attributes['Clipart'] = clipart.name
	}

	return result
}

// ---------------------------------------------------------------------------
// Created Bracelets TIB validation
// DORMANT (2026-08-28): Created Bracelets products are no longer carried. No TIB-enabled product
// carries this vendor, so this validator has nothing to fire on. Kept on purpose in case the line
// returns — do not delete, and do not treat it as a live path. See VYT-409.
// (Placeholder — options not yet configured in TIB)
// ---------------------------------------------------------------------------

function validateTIBCreatedBracelets(result) {
	const engravingText = getTIBSelectText('Engraving')
	if (engravingText) result.attributes['Add Engraving'] = engravingText

	const lines = getTIBTextLines()
	let missingRequired = false
	lines.forEach((line, idx) => {
		if (line.required && line.value === '') {
			tibMarkError(line.fieldEl, result)
			result.valid = false
			missingRequired = true
		} else if (line.value !== '') {
			result.attributes[`Line ${idx + 1}`] = line.value
		}
	})
	if (missingRequired) {
		result.errors.push('Please complete all required fields')
	}

	const fontText = getTIBSelectText('Font')
	if (fontText && fontText !== 'Choose an option') {
		result.attributes['Font'] = fontText
	}

	return result
}

// ---------------------------------------------------------------------------
// Legacy Customily validators (kept for any products not yet on TIB)
// ---------------------------------------------------------------------------

function validateTerrybearCustomily(container, result) {
	const personalizeSelect = container.querySelector('select')
	if (!personalizeSelect) return result

	const customilyInputs = container.querySelectorAll('input')
	const personalizationType = personalizeSelect.value

	switch (personalizationType) {
		case 'No':
			result.attributes['Add Engraving'] = 'No'
			break
		case 'Text Only':
			return validateTerrybearTextOnly(container, customilyInputs, result)
		case 'Text + Clipart':
			return validateTerrybearTextAndClipart(container, customilyInputs, result)
		default:
			result.valid = false
			result.errors.push('No personalization options selected, please try again')
			break
	}

	return result
}

function validateTerrybearTextOnly(container, customilyInputs, result) {
	result.attributes['Add Engraving'] = 'Yes'
	let lineCounter = 1
	let text1Found = false
	let text1Empty = false

	for (const input of customilyInputs) {
		if (input.parentElement) input.parentElement.style.border = 'revert'

		if (input.name === 'properties[Text 1]') {
			text1Found = true
			if (input.value === '') {
				text1Empty = true
				if (input.parentElement) {
					input.parentElement.style.border = 'red 2px solid'
					result.elementsWithErrors.push(input.parentElement)
				}
			} else {
				result.attributes[`Line ${lineCounter++}`] = input.value
			}
		} else if (input.name === 'properties[Font]') {
			if (input.value) result.attributes['Font'] = input.value
		} else if (input.value) {
			result.attributes[`Line ${lineCounter++}`] = input.value
		}
	}

	if (text1Found && text1Empty) {
		result.valid = false
		result.errors.push('Please complete all required fields')
	}

	return result
}

function validateTerrybearTextAndClipart(container, customilyInputs, result) {
	result.attributes['Add Engraving'] = 'Yes'
	const swatchContainer = container.querySelector('.swatch-container')
	if (swatchContainer) swatchContainer.style.border = 'none'

	let lineCounter = 1
	let text1Found = false
	let text1Empty = false
	let clipartCount = 0

	for (const input of customilyInputs) {
		if (input.parentElement) input.parentElement.style.border = 'revert'
		if (input.name === '') continue

		if (input.name === 'properties[Text 1]') {
			text1Found = true
			if (input.value === '') {
				text1Empty = true
				if (input.parentElement) {
					input.parentElement.style.border = 'red 2px solid'
					result.elementsWithErrors.push(input.parentElement)
				}
			} else {
				result.attributes[`Line ${lineCounter++}`] = input.value
			}
		} else if (input.name === 'properties[Font]') {
			if (input.value) result.attributes['Font'] = input.value
		} else if (input.name === 'properties[Vector Selection 5]') {
			if (input.checked) {
				result.attributes['Clipart'] = input.value
				clipartCount++
			}
		} else if (input.value) {
			result.attributes[`Line ${lineCounter++}`] = input.value
		}
	}

	if (text1Found && text1Empty) {
		result.valid = false
		result.errors.push('Please complete all required fields')
	}

	if (clipartCount !== 1) {
		result.valid = false
		result.errors.push('Please select one image')
		if (swatchContainer) {
			swatchContainer.style.border = 'red 2px solid'
			result.elementsWithErrors.push(swatchContainer)
		}
	}

	return result
}

function validateMacKenzieVaultCustomily(container, result) {
	const customilyInputs = container.querySelectorAll('select, input, textarea')
	if (!customilyInputs || customilyInputs.length === 0) return result

	let lineCounter = 1
	let colorSelected = false

	for (const input of customilyInputs) {
		if (input.parentElement) input.parentElement.style.border = 'revert'

		// Skip unchecked radio buttons — iterating all would always capture the last value
		if (input.type === 'radio' && !input.checked) continue

		switch (input.name) {
			case 'properties[Color]':
				if (input.value) {
					result.attributes['Color'] = input.value
					colorSelected = true
				}
				break
			case 'properties[Engraving]':
				if (input.value) result.attributes['Add Engraving'] = input.value
				break
			case 'properties[Etch Color]':
				if (input.value) result.attributes['Etch Color'] = input.value
				break
			case 'properties[Line 1]':
			case 'properties[Line 2]':
			case 'properties[Line 3]':
			case 'properties[Line 4]':
				if (input.value) result.attributes[`Line ${lineCounter++}`] = input.value
				break
			default:
				break
		}
	}

	if (!colorSelected) {
		result.valid = false
		result.errors.push('Please select a color')
		const swatchContainer = container.querySelector('.swatch-container')
		if (swatchContainer) {
			swatchContainer.style.border = 'red 2px solid'
			result.elementsWithErrors.push(swatchContainer)
		}
	}

	return result
}

function validateCreatedBraceletsCustomily(container, result) {
	const customilyInputs = container.querySelectorAll('select, input, textarea')
	if (!customilyInputs || customilyInputs.length === 0) return result

	let customTextFound = false
	let customTextEmpty = false
	let nameCounter = 1
	let initialCounter = 1

	for (const input of customilyInputs) {
		if (input.parentElement) input.parentElement.style.border = 'revert'

		if (input.name === 'properties[Custom Text]') {
			customTextFound = true
			if (input.value === '') {
				customTextEmpty = true
				if (input.parentElement) {
					input.parentElement.style.border = 'red 2px solid'
					result.elementsWithErrors.push(input.parentElement)
				}
			}
		}

		switch (input.name) {
			case 'properties[Wrist Size (inches)]':
				if (input.value) result.attributes['Size'] = input.value
				break
			case 'properties[Flower]':
				if (input.value) result.attributes['Flower'] = input.value
				break
			case 'properties[Custom Text Engraving]':
				if (input.value) result.attributes['Add Engraving'] = input.value
				break
			case 'properties[Font]':
				if (input.value) result.attributes['Font'] = input.value
				break
			case 'properties[Custom Text]':
				if (input.value) result.attributes['Text'] = input.value
				break
			case 'properties[Charms]':
				if (input.value) result.attributes['Charms'] = input.value
				break
			case 'properties[Discs]':
				if (input.value) result.attributes['Discs'] = input.value
				break
			default:
				if (input.name.includes('Name') && input.value) {
					result.attributes[`Name ${nameCounter++}`] = input.value
				} else if (input.name.includes('Initial') && input.value) {
					result.attributes[`Initial ${initialCounter++}`] = input.value
				}
				break
		}
	}

	if (customTextFound && customTextEmpty) {
		result.valid = false
		result.errors.push('Please complete all required fields')
	}

	return result
}

// Hide product page breadcrumbs in retail modes
// Scope: product pages only; safe no-op elsewhere
window.hideProductBreadcrumbs = function(mode) {
	try {
		// Heuristic to detect product pages without relying on template classes
		const isProductPage = !!document.querySelector(
			'[id^="product-form-"], product-form, section[id^="shopify-section-main-product"], .product'
		)
		if (!isProductPage) {
			// if we're not on a product page, remove any stray back-link
			document.querySelectorAll('.breadcrumb-back-link').forEach(el => el.remove())
			return
		}

		if (mode === 'b2b') {
			// restore normal breadcrumbs and remove any back link
			document
				.querySelectorAll(
					'.breadcrumb, .breadcrumbs, nav.breadcrumbs, .product__breadcrumbs, .breadcrumbs-wrapper'
				)
				.forEach((el) => {
					el.style.display = ''
				})
			document.querySelectorAll('.breadcrumb-back-link').forEach(el => el.remove())
			return
		}

		// hide the standard breadcrumbs
		document
			.querySelectorAll(
				'.breadcrumb, .breadcrumbs, nav.breadcrumbs, .product__breadcrumbs, .breadcrumbs-wrapper'
			)
			.forEach((el) => {
				el.style.display = 'none'
			})

		// insert a simple "back" link if not already present
		if (!document.querySelector('.breadcrumb-back-link')) {
			const backLink = document.createElement('a')
			backLink.href = 'javascript:void(0)'
			backLink.textContent = '← Back'
			backLink.setAttribute('aria-label', 'Go back')
			backLink.className = 'breadcrumb-back-link body-small focus-inset'
			// ensure retail mode persists; use full reload when going back
			backLink.addEventListener('click', (ev) => {
				ev.preventDefault()
				const isRetail = window.retailContext && window.retailContext.mode === 'retail'
				if (isRetail && document.referrer) {
					window.location.href = document.referrer
				} else {
					window.history.back()
				}
			})
			// prefer inserting where breadcrumbs originally were
			const breadcrumbs = document.querySelectorAll(
				'.breadcrumb, .breadcrumbs, nav.breadcrumbs, .product__breadcrumbs, .breadcrumbs-wrapper'
			)
			if (breadcrumbs.length && breadcrumbs[0].parentElement) {
				breadcrumbs[0].parentElement.insertBefore(backLink, breadcrumbs[0])
			} else {
				const container = document.querySelector('.product__info-container') || document.body
				container.prepend(backLink)
			}
		}
	} catch (e) {
		console.warn('[RETAIL MODE] hideProductBreadcrumbs error:', e)
	}
}

// Hide restricted menu items (Brands, Training, etc.) in retail modes
window.hideRestrictedMenuItems = function(mode) {
	if (mode === 'b2b') {
		// B2B users see all menu items - restore visibility
		const desktopLinks = document.querySelectorAll('.header__inline-menu a.header__menu-item')
		desktopLinks.forEach(link => {
			if (link.parentElement) link.parentElement.style.display = ''
		})
		const mobileItems = document.querySelectorAll('.menu-drawer__menu li')
		mobileItems.forEach(item => {
			item.style.display = ''
		})
		return
	}
	
	// Define keywords to hide based on mode
	let restrictedKeywords
	if (mode === 'retail-generic') {
		// Retail-generic: hide brands, training, resources, but SHOW "about us" and "news"
		restrictedKeywords = ['brands', 'brand', 'training', 'resource']
	} else if (mode === 'retail') {
		// Full retail: hide brands, training, resources, news, AND "about us"
		restrictedKeywords = ['brands', 'brand', 'training', 'resource', 'news', 'about']
	} else {
		// Unknown mode - default to hiding everything except shop
		restrictedKeywords = ['brands', 'brand', 'training', 'resource', 'news', 'about']
	}
	
	// Hide desktop menu items (including nested submenu items)
	const desktopLinks = document.querySelectorAll('.header__inline-menu a.header__menu-item')
	desktopLinks.forEach(link => {
		const itemText = link.innerText.trim().toLowerCase()
		const shouldHide = restrictedKeywords.some(keyword => itemText.includes(keyword))
		if (link.parentElement) {
			link.parentElement.style.display = shouldHide ? 'none' : ''
		}
	})
	
	// Hide mobile menu items (including nested submenu items)
	const mobileItems = document.querySelectorAll('.menu-drawer__menu li')
	mobileItems.forEach(item => {
		const linkElement = item.querySelector('a, button, summary')
		const itemText = linkElement ? linkElement.innerText.trim().toLowerCase() : item.innerText.trim().toLowerCase()
		const shouldHide = restrictedKeywords.some(keyword => itemText.includes(keyword))
		item.style.display = shouldHide ? 'none' : ''
	})
}

// Expose for retail-showroom.js to re-apply prices after dynamic content loads
window.initRetailBranding = initRetailBranding
window.initB2BEngravingPrices = initB2BEngravingPrices

// Init - global.js is deferred so DOM is always ready
const retailContext = window.retailContext || {}
if (retailContext.mode === 'retail') {
	initRetailBranding()
} else if (retailContext.mode === 'b2b' && retailContext.isB2B) {
	// B2B mode: load B2B engraving prices only for authenticated B2B users
	initB2BEngravingPrices()
}

// VariantSelects.renderProductInfo() replaces the "Price" block's entire innerHTML
// (server-rendered native Shopify price + new SKU) whenever the shopper switches
// variants. Re-apply our own pricing right after so multi-variant products (e.g.
// MacKenzie Vault Finish variants) show the correct price for the newly selected
// variant instead of Shopify's native one, in both retail and B2B modes.
const priceWrapperEl = document.querySelector('.price-wrapper')
if (priceWrapperEl) {
	const priceRefreshObserver = new MutationObserver(() => {
		const mode = window.retailContext?.mode
		if (mode === 'retail') initRetailBranding()
		else if (mode === 'b2b') initB2BEngravingPrices()
	})
	priceRefreshObserver.observe(priceWrapperEl, { childList: true })
}
// Apply menu visibility on initial load (with timeout to ensure menu is fully rendered)
setTimeout(() => {
	const mode = window.retailContext?.mode || 'b2b'
	window.hideRestrictedMenuItems(mode)
	// Hide breadcrumbs on product pages in retail modes
	window.hideProductBreadcrumbs(mode)
	// Ensure vendor labels are not announced by screen readers in retail modes
	if (typeof window.toggleVendorAccessibility === 'function') {
		window.toggleVendorAccessibility(mode)
	}
}, 100)

// React to retail mode toggles after initial load
const watchRetailModeChanges = () => {
	const rootEl = document.documentElement

	// Shared cleanup when leaving retail mode (used by both b2b and retail-generic paths)
	const cleanupRetailMode = () => {
		document.querySelectorAll('.price-container.price-ready').forEach(el => {
			el.classList.remove('price-ready')
		})

		// Reset CSS variables to their original values
		const root = document.documentElement
		if (window.defaultCssVars) {
			Object.entries(window.defaultCssVars).forEach(([varName, defaultValue]) => {
				if (defaultValue) {
					root.style.setProperty(varName, defaultValue)
				}
			})
		}

		// Re-show SparkLayer UI elements that were hidden in retail mode
		const sparkElements = document.querySelectorAll('spark-pdp, [data-spark], .spark-cart, .spark-account, .spark-modal')
		sparkElements.forEach(el => {
			el.style.display = ''  // Clear inline display style to allow CSS to apply
		})

		// Always restore header logo state when leaving retail mode.
		const headerLinks = document.querySelectorAll('.header__heading-link')
		for (const link of headerLinks) {
			const originalLogo = link.querySelector('img:not(.retail-branded-logo)')
			const brandedLogo = link.querySelector('img.retail-branded-logo')
			if (originalLogo) originalLogo.classList.remove('hidden')
			if (brandedLogo) brandedLogo.classList.add('hidden')
		}
		root.style.removeProperty('--retail-logo-url')
	}

	const applyModeEffects = () => {
		const mode = rootEl.getAttribute('data-retail-mode')
		const ctx = window.retailContext || {}
		
		// Update retail context mode
		if (window.retailContext) {
			window.retailContext.mode = mode
		}
		
		// When switching into retail mode, fetch branding + pricing
		if (mode === 'retail' && ctx.slug) {
			initRetailBranding()
		} else if (mode === 'b2b') {
			// Switching back to B2B: clean up retail UI then reload B2B engraving prices
			cleanupRetailMode()
			const engravingDisplay = document.getElementById('engraving-price-display')
			if (engravingDisplay) engravingDisplay.remove()
			window._engravingObserverActive = false
			initB2BEngravingPrices()
		} else {
			// Leaving retail to retail-generic or unknown mode
			cleanupRetailMode()
		}
		
		// Apply menu visibility based on mode
		window.hideRestrictedMenuItems(mode)
		// Ensure breadcrumbs visibility aligns with mode on product pages
		window.hideProductBreadcrumbs(mode)
		// Toggle vendor label accessibility based on mode
		if (typeof window.toggleVendorAccessibility === 'function') {
			window.toggleVendorAccessibility(mode)
		}
		// Sync showroom filtering when retail mode changes
		if (window.RetailShowroom && typeof window.RetailShowroom.handleModeChange === 'function') {
			window.RetailShowroom.handleModeChange(mode)
		}
	}
	
	// Observe attribute changes to data-retail-mode
	const mo = new MutationObserver((mutations) => {
		for (const m of mutations) {
			if (m.type === 'attributes' && m.attributeName === 'data-retail-mode') {
				applyModeEffects()
			}
		}
	})
	mo.observe(rootEl, { attributes: true })
}

// Accessibility: hide vendor-only labels from screen readers in retail modes
// This avoids announcing vendor identifiers when white-labeling is active.
// In B2B mode, restore accessibility (remove aria-hidden).
window.toggleVendorAccessibility = (mode) => {
	try {
		const hideForRetail = mode !== 'b2b'
		// Common visually-hidden classes and potential vendor label candidates
		const candidates = document.querySelectorAll('.visually-hidden, .sr-only, [aria-label], [data-vendor-label]')
		candidates.forEach(el => {
			const text = (el.textContent || '').trim().toLowerCase()
			const isVendorLabel = text.startsWith('vendor') || el.getAttribute('aria-label')?.toLowerCase() === 'vendor'
			if (isVendorLabel) {
				if (hideForRetail) {
					el.setAttribute('aria-hidden', 'true')
				} else {
					el.removeAttribute('aria-hidden')
				}
			}
		})
	} catch (e) {
		console.warn('toggleVendorAccessibility error:', e)
	}
}

// Intercept cart icon clicks for B2B users in retail mode to prevent SparkLayer hijacking.
// True retail users (unauthenticated) use CartDrawer's native click handler without interception.
const setupCartModeInterception = () => {
	const handleCartIconClick = (e) => {
		// Only intercept for authenticated B2B users who have toggled to retail mode
		const ctx = window.retailContext || {};
		if (!ctx.isB2B || ctx.mode !== 'retail') return;
		
		// Check if this is a cart icon click
		const cartIcon = e.target.closest('#cart-icon-bubble');
		if (!cartIcon) return;
		
		// Prevent SparkLayer from hijacking the click
		e.preventDefault();
		e.stopImmediatePropagation();
		
		// Manually open the CartDrawer element
		const drawer = document.querySelector('cart-drawer');
		if (drawer && typeof drawer.open === 'function') {
			drawer.open(cartIcon);
		}
	};
	
	// Use capture phase to intercept before SparkLayer
	document.addEventListener('click', handleCartIconClick, true);
};

setupCartModeInterception();

// Cart Bubble Sync: Keep bubble in sync with correct cart based on mode
// Wait for SparkLayer to be ready before getting cart
window.waitForSparkLayer = async (timeout = 5000) => {
	const startTime = Date.now()
	while (!window.spark && Date.now() - startTime < timeout) {
		await new Promise(resolve => setTimeout(resolve, 100))
	}
	return window.spark
}

window.getCartCountForMode = async (mode) => {
	if (mode === 'retail') {
		// Get Shopify cart count
		try {
			const response = await fetch(`${window.Shopify.routes.root}cart.js`)
			const cart = await response.json()
			return cart.item_count
		} catch (err) {
			console.warn('Failed to fetch Shopify cart count:', err)
			return 0
		}
	} else if (mode === 'b2b') {
		// Get SparkLayer cart count (if available)
		// Wait for SparkLayer to initialize before trying to get cart
		const spark = await window.waitForSparkLayer()
		if (spark) {
			try {
				const cart = await spark.getCart()
				return cart.items.reduce((sum, item) => sum + item.quantity, 0)
			} catch (err) {
				console.warn('Failed to fetch SparkLayer cart count:', err)
				// Fall back to Shopify cart in case SparkLayer fails
				try {
					const response = await fetch(`${window.Shopify.routes.root}cart.js`)
					const cart = await response.json()
					return cart.item_count
				} catch (e) {
					return 0
				}
			}
		}
	}
	return 0
}

window.updateCartBubble = (itemCount) => {
	const cartCountBubble = document.querySelectorAll(".cart-count-bubble")
	for (const bubble of cartCountBubble) {
		for (const label of bubble.children) {
			label.innerText = label.innerText.includes("items") 
				? `${itemCount} items` 
				: `${itemCount}`
		}
	}
}

// Critical: Sync bubble when mode changes to prevent showing wrong cart count
window.syncBubbleToMode = async (mode) => {
	const count = await window.getCartCountForMode(mode)
	window.updateCartBubble(count)
}

// Listen for cart updates from both retail and SparkLayer and update bubble appropriately
if (document) {
	document.addEventListener('cart:updated', async (event) => {
		// Determine which cart to display based on current mode
		if (window.retailContext?.mode === 'retail') {
			// Retail mode: use Shopify cart
			const count = await window.getCartCountForMode('retail')
			window.updateCartBubble(count)
		} else if (window.retailContext?.mode === 'b2b') {
			// B2B mode: use SparkLayer cart
			const count = await window.getCartCountForMode('b2b')
			window.updateCartBubble(count)
		}
	})
}

// =============================================================================
// Engraving Service SKU Reconciliation Utilities
// Used by cart.js to auto-correct orphaned service SKU quantities when a main
// product is removed or its quantity is reduced. Keep the SKU set in sync with
// retail-cart.js and SparkLayer's preCartUpdateListener in theme.liquid.
// =============================================================================

const ENGRAVING_SERVICE_SKUS = new Set(['ENGTEXT', 'ENGART', 'CBENGRAVING', 'MVSTANDARD', 'MVCUSTOM', 'MVFULLFRAME'])

/**
 * Given a Shopify cart items array, compute the expected total quantity of each
 * engraving service SKU based on the remaining main product line attributes.
 *
 * Rules ("Add Engraving" is always "Yes" or "No"):
 *   Terrybear + Clipart present  => ENGART
 *   Terrybear + no Clipart       => ENGTEXT
 *   Created Bracelets (Yes)      => CBENGRAVING  (DORMANT: vendor no longer carried, unreachable)
 *   MacKenzie Vault   (Yes)      => MVSTANDARD
 *
 * TODO: MacKenzie Vault currently only has one engraving SKU (MVSTANDARD).
 * When additional service SKUs are introduced, the correct one will need to be
 * inferred from other line item attributes — same pattern as Terrybear uses the
 * Clipart attribute. Update this function accordingly at that time.
 *
 * @param {Array} items - Shopify cart items array
 * @returns {Object} Map of SKU -> expected total quantity
 */
function getExpectedEngravingTotals(items) {
	const expected = {}
	for (const item of items) {
		if (ENGRAVING_SERVICE_SKUS.has(item.sku)) continue
		const props = item.properties || {}
		// Teeinblue items don't store a human-readable engraving value in cart properties.
		// retail-cart.js writes _engraving_sku at add-time so we can reconcile qty changes.
		const directSku = props['_engraving_sku']
		if (directSku && ENGRAVING_SERVICE_SKUS.has(directSku)) {
			expected[directSku] = (expected[directSku] || 0) + item.quantity
			continue
		}
		const engraving = props['Add Engraving'] || props['Engraving']
		if (!engraving || engraving === 'No') continue
		const vendor = item.vendor || props['_vendor']
		let sku = null
		if (vendor === 'Terrybear') {
			sku = ('Clipart' in props) ? 'ENGART' : 'ENGTEXT'
		} else if (vendor === 'Created Bracelets') {
			sku = 'CBENGRAVING'
		} else if (vendor === 'MacKenzie Vault') {
			// TODO: See function-level TODO above before adding more MacKenzie SKUs.
			sku = 'MVSTANDARD'
		}
		if (sku) {
			expected[sku] = (expected[sku] || 0) + item.quantity
		}
	}
	return expected
}

/**
 * Compare expected vs actual service SKU quantities in a cart items array and
 * return only the adjustments needed. A quantity of 0 means remove the line.
 *
 * A service SKU can occupy more than one line (a duplicate left behind by an
 * earlier build, or by any path that writes different line properties). Those
 * lines are consolidated, not treated independently: the first line for a SKU
 * carries the whole expected quantity and every extra line is zeroed out.
 * Giving each matching line the full expected total would double the engraving
 * charge and, because the result then "matches expectations", would keep being
 * re-asserted on every subsequent cart change instead of healing.
 *
 * @param {Array} items - Shopify cart items array
 * @returns {Array} [{ key: string, quantity: number }, ...]
 */
function getServiceSkuAdjustments(items) {
	const expected = getExpectedEngravingTotals(items)
	const adjustments = []
	const seen = new Set()
	for (const item of items) {
		if (!ENGRAVING_SERVICE_SKUS.has(item.sku)) continue
		const isFirstLine = !seen.has(item.sku)
		seen.add(item.sku)
		const expectedQty = isFirstLine ? (expected[item.sku] || 0) : 0
		if (item.quantity !== expectedQty) {
			adjustments.push({ key: item.key, quantity: expectedQty })
		}
	}
	return adjustments
}

// Start watching for mode changes
watchRetailModeChanges()
